import { render, staticRenderFns } from "./BookingUpsells.vue?vue&type=template&id=63ed25f2"
import script from "./BookingUpsells.vue?vue&type=script&lang=js"
export * from "./BookingUpsells.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports